import React, { FunctionComponent } from 'react'
import { Layout, OrderedList } from '@vwfs-bronson/bronson-react'
import TextsRender from '../TextsRender/TextsRender'
import { Output } from '../../../Text'

export type OrderedListRenderProps = {
  orderedList: any,
  templateValues?: any,
}

const OrderedListRender: FunctionComponent<OrderedListRenderProps> = props => {
  const { orderedList, templateValues } = props;

  return (
    orderedList
      ? (
          <Layout>
            {orderedList?.prefix?.length > 0 && (
              <Layout.Item>
                <TextsRender
                  texts={orderedList?.prefix}
                  templateValues={templateValues}
                />
              </Layout.Item>
            )}
            {orderedList?.items?.length > 0 && (
              <Layout.Item>
                <OrderedList>
                  {orderedList?.items?.map(
                    (item: string) => (
                      <OrderedList.Item key={item}>
                        {Output.markdown(
                          Output.templateWithValues(item, templateValues)
                        )}
                      </OrderedList.Item>
                    )
                  )}
                </OrderedList>
              </Layout.Item>
            )}
            {orderedList?.suffix?.length > 0 && (
              <Layout.Item>
                <TextsRender
                  texts={orderedList?.suffix}
                  templateValues={templateValues}
                />
              </Layout.Item>
            )}
        </Layout>
      )
      : <></>
  )
}

export default OrderedListRender;
